module.exports = __webpack_public_path__ + "assets/img/block-hover-6e88c648.png";